import u from '@/js/utils'
/**
 * 数据适配器，用于把后台返回的数据处理成前端需要的数据
 * @param {string} interfaceName  接口名
 * @param {object} res  接口返回的数据
 * @param {object} otherData  由外部提供的其他数据
 */
const adaptor = function (interfaceName, res, otherData) {
    return dataHandler[interfaceName](res,otherData);
}
const dataHandler = {
    'input':function (data,otherData) {
        const originData = data['boxlist'];
        const hlBrands = otherData.type?otherData.type:[];
        if (!originData) return ;
        return originData.map(box => {//处理数据，适配前端使用
            const item = {};
            item.label = box.label;
            const children = box.children.map(child => {
                child.unit = u.getUnit(child.label);
                child.label = u.getLabel(child.label);
                if (child.label==='葫芦品牌'&&hlBrands.length>0){//拼接葫芦品牌的数据
                    child.selectValue = hlBrands;
                }
                if (child.label==='项目号'&&!!child.value){
                    child.disabled=true;
                }
                return child;
            });
            item.childrenLeft = children.filter((child, index) => index % 2 === 0);
            item.childrenRight = children.filter((child, index) => index % 2 === 1);
            return item;
        });
    },

};


export default adaptor;
